'use client'

import { ReactNode } from 'react'

import { Popup } from '@dfds-pax/shared-components/client'

interface Props {
  children?: ReactNode
  dataAttr: string
  description?: string
  headline: string
  onPrimaryButtonClicked?: () => void
  onRequestClose?: () => void
  onSecondaryButtonClicked?: () => void
  primaryButtonText?: string
  secondaryButtonText?: string
  show: boolean
}

const Dialog = ({
  children,
  dataAttr,
  description,
  headline,
  onPrimaryButtonClicked,
  onRequestClose,
  onSecondaryButtonClicked,
  primaryButtonText,
  secondaryButtonText,
  show,
}: Props) => (
  <Popup
    dataAttr={dataAttr}
    description={description}
    headline={headline}
    onPrimaryButtonClicked={onPrimaryButtonClicked}
    onRequestClose={onRequestClose}
    onSecondaryButtonClicked={onSecondaryButtonClicked}
    primaryButtonText={primaryButtonText}
    secondaryButtonText={secondaryButtonText}
    show={show}
  >
    {children}
  </Popup>
)

export default Dialog
